import React from 'react';
export function SolutionSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-335">
      <div className="max-w-4xl mx-auto text-center" data-id="element-336">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 border border-[#39FF14]/50 text-[#39FF14] font-bold text-sm px-5 py-2 rounded-full mb-8 tracking-wide" data-id="element-337">
          🏆 Sistema N°1 para Docentes de Português en Argentina
        </div>

        <h2 className="text-4xl sm:text-5xl font-black text-white mb-4" data-id="element-338">
          🇧🇷 PROFEPACK™
        </h2>
        <h3 className="text-2xl sm:text-3xl font-bold text-[#39FF14] mb-6" data-id="element-339">
          MEGAPACK PORTUGUÊS LISTO
        </h3>
        <p className="text-white text-lg max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-340">
          <strong data-id="element-341">
            540 páginas. Solucionario completo. Planificación anual lista. Listo
            para usar desde hoy.
          </strong>
        </p>

        {/* Mockup visual */}
        <div className="relative mx-auto mb-10 max-w-2xl" data-id="element-342">
          <div className="grid grid-cols-6 gap-2 justify-center" data-id="element-343">
            {['#1565C0', '#2E7D32', '#E65100', '#6A1B9A', '#37474F', '#BF360C'].map((color, i) => {
            const labels = ['N1', 'N2', 'N3', 'N4', 'N5', 'N6'];
            return <div key={i} className="aspect-[3/4] rounded-lg shadow-2xl flex items-end justify-center pb-2" style={{
              backgroundColor: color,
              border: '2px solid #39FF14'
            }} data-id="element-344">
                  <span className="text-white text-xs font-bold" style={{
                textShadow: '0 1px 3px rgba(0,0,0,0.8)'
              }} data-id="element-345">
                    {labels[i]}
                  </span>
                </div>;
          })}
          </div>
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-[#39FF14] text-black font-black text-xs px-4 py-1 rounded-full whitespace-nowrap" data-id="element-346">
            6 TOMOS COMPLETOS
          </div>
        </div>

        {/* Pills */}
        <div className="flex flex-wrap items-center justify-center gap-3 mt-8" data-id="element-347">
          <span className="bg-[#39FF14]/10 border border-[#39FF14]/40 text-[#39FF14] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-348">
            ✅ Por nivel (Todos los niveles)
          </span>
          <span className="bg-[#39FF14]/10 border border-[#39FF14]/40 text-[#39FF14] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-349">
            ✅ Con planificación anual lista
          </span>
          <span className="bg-[#39FF14]/10 border border-[#39FF14]/40 text-[#39FF14] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-350">
            ✅ Con solucionario completo
          </span>
          <span className="bg-[#39FF14]/10 border border-[#39FF14]/40 text-[#39FF14] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-351">
            ✅ Con evaluaciones y rúbricas
          </span>
          <span className="bg-[#39FF14]/10 border border-[#39FF14]/40 text-[#39FF14] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-352">
            ✅ Con bonos incluidos
          </span>
          <span className="bg-[#39FF14]/10 border border-[#39FF14]/40 text-[#39FF14] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-353">
            ✅ Con conexión cultural Brasil-Argentina
          </span>
          <span className="bg-[#39FF14]/10 border border-[#39FF14]/40 text-[#39FF14] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-354">
            ✅ Falsos Amigos integrados en todos los niveles
          </span>
        </div>
      </div>
    </section>;
}